import { Button } from 'antd';
import type { ButtonProps } from 'antd/es/button';
import React from 'react';
import { QueryClient } from 'react-query';
import { useLogout } from './useLogout';

interface LogoutButtonProps extends ButtonProps {
  children?: React.ReactNode;
  context: {
    queryClient: QueryClient;
  };
}

export function LogoutButton(props: LogoutButtonProps) {
  const { children = 'Logout', context, ...buttonProps } = props;
  const { logout, isLoading } = useLogout({
    onLogout: () => context.queryClient.clear(),
  });
  if (!logout) return null;

  const handleClick = () => {
    logout();
  };

  return (
    <Button
      type="primary"
      onClick={handleClick}
      loading={isLoading}
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
